<main class="p-4 container-lg">
  <div class="row">
    <div class="col-12 col-md-6 offset-md-3">
      <h2>Reset Password</h2>
      @if(!complete){
      <p>Enter your email address and a new password.</p>
      <form [formGroup]="form" (ngSubmit)="submit()">
        <div class="form-group row mb-3">
          <div class="col">
            <label for="email" class="form-label">Email</label>
            <input type="text" tabindex="1" class="form-control" placeholder="user@email.com" formControlName="email">
            <div class="text-danger" *ngIf="formControl.email.touched && formControl.email.errors?.required">
              Email is required
            </div>
          </div>
        </div>
        <div class="form-group row mb-3">
          <div class="col">
            <label for="password" class="form-label">New Password</label>
            <input type="password" tabindex="2" class="form-control" formControlName="newPassword">
            <div class="text-danger" *ngIf="formControl.newPassword.touched && formControl.newPassword.errors?.required">
              New password is required
            </div>
          </div>
        </div>
        <div class="form-group row mb-3">
          <div class="col">
            <label for="confirmNewPassword" class="form-label">Confirm New Password</label>
            <input type="password" tabindex="3" class="form-control" formControlName="confirmNewPassword">
            <div class="text-danger" *ngIf="formControl.confirmNewPassword.touched && formControl.confirmNewPassword.errors?.required">
              Confirm new password is required
            </div>
            <div class="text-danger" *ngIf="formControl.confirmNewPassword.value != '' && formControl.newPassword.touched && formControl.confirmNewPassword.touched && form.errors?.PasswordNoMatch">
              Passwords do not match.
            </div>            
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-12 col-sm-6">
            <button type="submit" tabindex="4" class="btn btn-primary px-5" [disabled]="working">
              <i class="fa-solid fa-lock" [class]="{'fa-lock': !working, 'fa-spinner': working, 'fa-spin': working}"></i> Reset Password
            </button>
          </div>
          <div class="col-12 col-sm-6 text-end">
            <a routerLink="/login">Back to login</a>
          </div>
        </div>
      </form>
      @if(hasError && !working){
      <div class="alert alert-danger mt-3" >
        An error occurred while trying to reset your password. Please verify the information you have entered and try again.
      </div>
      }
     }
      @else if(complete){
        <p>Your password has been reset successfully.</p>
        <a routerLink="/login">Back to login</a>
      }
    </div>
  </div>
</main>
